import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { SEARCH_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useSearchCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useSearchCarNotSold() {
  const { startListen } = useWebSocketStore()
  const { updateSearchCar } = useUpdateCar()

  const carNotSold = () => {
    startListen({
      eventName: 'premium.CAR_NOT_SOLD',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId } = event.context

        updateSearchCar(carId, (data) => {
          return {
            ...data,
            state: 'NOT_SOLD',
          }
        })
      },
    })
  }

  return { carNotSold }
}
